import {
    Card,
    CardBody,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "@heroui/react";
import { LuFlaskConical, LuPenTool } from "react-icons/lu";
import { ThemedText } from "@/components/ui";

const MethodSelectModal = ({
    isOpen,
    onClose,
    onSelectManual,
    onSelectFormula,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalContent>
                {() => (
                    <>
                        <ModalHeader>Pilih Metode Produksi</ModalHeader>
                        <ModalBody>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <MethodCard
                                    title="Racik Manual"
                                    description="Tentukan bahan baku dan jumlah secara manual tanpa rumus."
                                    icon={<LuPenTool size={20} />}
                                    onClick={onSelectManual}
                                />
                                <MethodCard
                                    title="Gunakan Formula"
                                    description="Otomatis isi bahan baku berdasarkan rumus resep yang ada."
                                    icon={<LuFlaskConical size={20} />}
                                    onClick={onSelectFormula}
                                />
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="danger"
                                variant="light"
                                onPress={onClose}
                            >
                                Batal
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

const MethodCard = ({ title, description, icon, onClick }) => (
    <Card
        isPressable
        onPress={onClick}
        className="hover:border-primary-500 border-default-200 border-2 transition-colors"
        shadow="none"
    >
        <CardBody className="items-center gap-3 p-5 text-center">
            <div className="bg-default-100 text-default-600 rounded-full p-3">
                {icon}
            </div>
            <div className="flex flex-col gap-1">
                <ThemedText size="md" className="font-semibold">
                    {title}
                </ThemedText>
                <ThemedText size="xs" variant="secondary">
                    {description}
                </ThemedText>
            </div>
        </CardBody>
    </Card>
);

export default MethodSelectModal;
